import { OptInLevelTriggers, OptInRewardLimit } from '../../Config/Bots';
import { ActionTypes } from '../Actions/Actions';
import * as fromActions from '../Actions/Actions';
import { IStateLevel } from './level';
import DateUtils from '../../Utils/DateUtils';
import { defaultStateSocial, IShareGiftData, IStateSocial } from '../socialHelpers';

export const StateSocial = (
    state = defaultStateSocial,
    action: fromActions.Actions
): IStateSocial => {
    switch (action.type) {
        case ActionTypes.ADD_INVITATION:
            const pendInv = [...state.pendingInvitations];
            if (pendInv.length < 10) {
                pendInv.push({ ts: Date.now(), id: action.payload });
            }
            pendInv.sort((a, b) => a.ts - b.ts);
            return {
                ...state,
                pendingInvitations: pendInv,
            };
        case ActionTypes.STORE_CONFIRMED_INVITE:
            const confInvites = [...state.confirmedInvitations];
            confInvites.push({
                avatar: action.payload[0],
                name: action.payload[1],
                userId: action.payload[2],
            });

            const pending = [...state.pendingInvitations];
            pending.filter(p => p.id !== action.payload[1]);

            return {
                ...state,
                confirmedInvitations: confInvites,
                pendingInvitations: pending,
            };
        case ActionTypes.ASK_FRIEND_START:
            return {
                ...state,
                helperFriend: action.payload,
            };
        case ActionTypes.ASK_FRIEND_COMPLETE:
            return {
                ...state,
                helperFriend: null,
            };
        case ActionTypes.INVITE_CONFIRMED:
            // remove from confirmed and add to stored with timestamp
            // stored to be cleared when timestamp is older than 2? days
            return {
                ...state,
            };
        case ActionTypes.STORE_RECEIVED_INVITE:
            const received = [...state.receivedInvitations];
            received.push({ ts: Date.now(), fromId: action.payload });
            return {
                ...state,
                receivedInvitations: received,
            };
        case ActionTypes.DELETE_INVITE_CONFIRMED:
            return {
                ...state,
                confirmedInvitations: [],
            };
        case ActionTypes.REMOVE_INVITATION:
            const confirmed = [...state.confirmedInvitations];
            const pends = [...state.pendingInvitations];
            const confirmedRemove = confirmed.find(i => i.userId === action.payload);
            const pendingRemove = pends.find(i => i.id === action.payload);

            if (confirmedRemove) {
                confirmed.splice(confirmed.indexOf(confirmedRemove), 1);
            }

            if (pendingRemove) {
                pends.splice(pends.indexOf(pendingRemove), 1);
            }

            pends.filter(p => {
                return Date.now() - p.ts < DateUtils.daysToMilliseconds(2);
            });

            return {
                ...state,
                pendingInvitations: pends,
                confirmedInvitations: confirmed,
            };
        case ActionTypes.OPT_IN_PROMT:
            return {
                ...state,
                optInRequired: true,
            };
        case ActionTypes.NATIVE_OPT_IN_PROMT:
            return {
                ...state,
                nativeOptInRequired: true,
            };
        case ActionTypes.OPT_IN_REWARDED:
            return {
                ...state,
                optInRewardDate: Date.now(),
            };
        case ActionTypes.OPT_IN_ACCEPTED:
            return {
                ...state,
                optInShown: false,
                optInRequired: false,
            };
        case ActionTypes.OPT_IN_SHOWN:
            return {
                ...state,
                optInRequired: false,
                nativeOptInRequired: false,
                optInShown: true,
            };
        case ActionTypes.OPT_IN_DISMISSED:
            return {
                ...state,
                optInShown: false,
                optInRequired: false,
            };
        case ActionTypes.RECEIVE_GIFT:
            const addGift = [...state.gifts];
            addGift.push(action.payload);
            return {
                ...state,
                gifts: addGift,
            };
        case ActionTypes.RECORD_GIFT:
            const deleteGift = [...state.gifts];
            deleteGift.splice(
                deleteGift.indexOf(deleteGift.find(f => f[0] === action.payload[0])),
                1
            );
            return {
                ...state,
                gifts: deleteGift,
            };
        case ActionTypes.RECEIVE_FRIENDGIFT:
            return {
                ...state,
                giftFromFriend: action.payload,
            };
        case ActionTypes.RECORD_FRIENDGIFT:
            return {
                ...state,
                giftFromFriend: '',
            };
        case ActionTypes.RECEIVE_MESSAGE:
            // TODO remove ids after some time so this doesn't keep growing
            const m = [...state.messageIds];
            m.push(action.payload);
            return {
                ...state,
                messageIds: m,
            };
        case ActionTypes.SEND_COINS:
            const newSentCoins = [...state.sentCoins].filter(x => x.friendId !== action.payload);
            newSentCoins.push({ friendId: action.payload, ts: Date.now() });
            return {
                ...state,
                sentCoins: newSentCoins,
            };
        case ActionTypes.RESET_SEND_COINS:
            const resetSentCoins = [...state.sentCoins].filter(x => x.friendId !== action.payload);
            resetSentCoins.push({ friendId: action.payload, ts: 0 });
            return {
                ...state,
                sentCoins: resetSentCoins,
            };
        case ActionTypes.SEND_GIFT:
            const newSentGifts = [...state.sentGifts].filter(x => x.friendId !== action.payload);
            newSentGifts.push({ friendId: action.payload, ts: Date.now() });
            return {
                ...state,
                sentGifts: newSentGifts,
            };
        case ActionTypes.RESET_SEND_GIFT:
            const resetSentGift = [...state.sentGifts].filter(x => x.friendId !== action.payload);
            resetSentGift.push({ friendId: action.payload, ts: 0 });
            return {
                ...state,
                sentGifts: resetSentGift,
            };
        case ActionTypes.ADD_GIFT_TO_COUNTER:
            return {
                ...state,
                sharedGiftsCount: state.sharedGiftsCount + 1,
            };
        case ActionTypes.RESET_GIFT_COUNTER:
            return {
                ...state,
                sharedGiftsCount: 0,
            };
        case ActionTypes.REQUEST_GIFT:
            const newRequestedGifts = [...state.requestedGifts].filter(
                x => x.friendId !== action.payload
            );
            newRequestedGifts.push({ friendId: action.payload, ts: Date.now() });
            return {
                ...state,
                requestedGifts: newRequestedGifts,
            };
        case ActionTypes.RESET_REQUEST_GIFT:
            const resetRequestedGifts = [...state.requestedGifts].filter(
                x => x.friendId !== action.payload
            );
            resetRequestedGifts.push({ friendId: action.payload, ts: 0 });
            return {
                ...state,
                requestedGifts: resetRequestedGifts,
            };
        default:
            return state;
    }
};

export function onOptInLevel(state: IStateLevel): boolean {
    return OptInLevelTriggers.indexOf(state.levelIndex) !== -1;
}

export function shouldRewardBots(state: IStateSocial): boolean {
    return state.optInRewardDate === 0 || Date.now() - state.optInRewardDate > OptInRewardLimit;
}

export function isMessageRecieved(state: IStateSocial, id: string): boolean {
    return state.messageIds.includes(id);
}

export function hasAlreadyBeenSentCoinsTo(state: IStateSocial, friendId: string): IShareGiftData {
    return state.sentCoins.find(x => x.friendId === friendId);
}

export function hasAlreadyBeenSentGiftTo(state: IStateSocial, friendId: string): IShareGiftData {
    return state.sentGifts.find(x => x.friendId === friendId);
}

export function hasAlreadyBeenRequestedGiftTo(
    state: IStateSocial,
    friendId: string
): IShareGiftData {
    return state.requestedGifts.find(x => x.friendId === friendId);
}

export function checkForNotification(timeStamps: IShareGiftData[], timer: number) {
    let counter = 0;
    timeStamps.forEach(element => {
        if (element.ts !== 0 && element.ts + timer < Date.now()) {
            counter++;
        }
    });

    return counter > 0;
}
